/**
 * String constants for the member-facing Resources feature.
 * No inline string literals in component code — all copy lives here.
 */
export const RESOURCES_STRINGS = {
  PAGE_TITLE: 'Resources',
  FEATURED_BADGE_PREFIX: 'FEATURED',
  ALL_RESOURCES_HEADING: 'All Resources',
  OPEN_RESOURCE: 'Open Resource →',
  VIEW_DETAILS: 'View Details',
  ADDED_PREFIX: 'Added',
  /**
   * Credit on a partner-provided resource (FR-278, MYN-189). Taken verbatim
   * from the ticket; B-65 asked whether it was right and nothing came back
   * contradicting it.
   */
  PROVIDED_BY: 'Provided by',
  LOAD_MORE: 'Load More',
  LOADING: 'Loading…',
  VIEW_MORE: 'View More',
  BROWSE_FOLDERS_HEADING: 'Browse by Category',
  FOLDER_VIEW_DETAILS_LABEL: (name: string) => `View details for ${name}`,
  FOLDER_ITEM_COUNT: (n: number) => `${n} ${n === 1 ? 'resource' : 'resources'}`,
  FOLDERS_EMPTY: {
    TITLE: 'No categories yet',
    DESCRIPTION: 'Check back soon — folders will appear here once the team sets them up.',
  },
  FOLDER_EMPTY: {
    TITLE: 'No resources in this folder',
    DESCRIPTION: 'This folder has no resources yet.',
  },
  DIALOG: {
    // Mirrors the card footer's "Open Resource →" action styling, with a
    // downward arrow for a download.
    SAVE: 'Save ↓',
    SAVING: 'Saving…',
    LOADING_PREVIEW: 'Loading preview…',
    NO_FILE: 'This resource has no file attached.',
    PREVIEW_UNAVAILABLE: 'This file type cannot be previewed here.',
    PREVIEW_UNAVAILABLE_HINT: 'Use Save to download it.',
    PREVIEW_TITLE: (title: string) => `Preview of ${title}`,
  },
  ERRORS: {
    LOAD_FAILED: 'Failed to load resources',
    DETAIL_LOAD_FAILED: 'Failed to load resource details',
    FOLDER_LOAD_FAILED: 'Failed to load folder',
    DOWNLOAD_FAILED: 'Could not save the file. Please try again.',
  },
} as const;
